import React, { useContext, useState, useEffect } from 'react'
import ModalContext from '../../contexts/ModalContext'
import UserContext from '../../contexts/UserContext'
import {
  Container,
  CloseDiv,
  HeaderText,
  Input,
  InputDiv,
  InputLabel,
  SelectInputMoviment,
  SelectInputKgOrMm,
  SelectOption,
  CloseImg,
  SwitchesDiv,
  SwitchDiv,
  SwitchLabel,
  SwitchBox,
  SwitchInput,
  SwitchSlider,
  InputText,
  NextButtonDiv,
  NextButtonImage,
  NextButtonText,
  ButtonsDiv,
  WarningDiv,
  WarningText,
  PreviousButtonDiv,
  PreviousButtonImage,
  PreviousButtonText,
  HeaderDiv,
  InputRowDiv,
} from './style'
import StockContext from '../../contexts/StockContext'
import cross from '../../assets/addStockModal/cross.svg'
import diskIcon from '../../assets/addStockModal/pages/disk.svg'
import arrowLeft from '../../assets/addStockModal/pages/arrow-left.svg'
import ApiService from '../../services/ApiService'
import { useTenant } from '../../contexts/TenantContext'
import { kgToMm, mmToKg } from '../../utils/stockGeometry'

const EntryOrExit = () => {
  const { setModalActive, setModalSection, itIsUpdate } = useContext(ModalContext)
  const { stock, setStock, setStockList, setRefresh } = useContext(StockContext)
  const { user } = useContext(UserContext)
  const { isFashionTenant } = useTenant()

  const isResource = (stock as any).isResource === true
  const shouldHideSwitches = isResource || isFashionTenant

  const [movementType, setMovementType] = useState<string>('Entrada')
  const [observation, setObservation] = useState<string>('')
  const [unitOfMeasurement, setUnitOfMeasurement] = useState<string>('KG')
  const [updateInOmie, setUpdateInOmie] = useState<boolean>(false)
  const [updateInStock, setUpdateInStock] = useState<boolean>(shouldHideSwitches)
  const [warningMessage, setWarningMessage] = useState<string>('')
  const [quantity, setQuantity] = useState<string>('')

  const [totalKg, setTotalKg] = useState<number | null>(null)
  const [totalMm, setTotalMm] = useState<number | null>(null)
  const [totalUnitQuantity, setTotalUnitQuantity] = useState<number | null>(null)

  useEffect(() => {
    if (shouldHideSwitches) {
      setUpdateInStock(true)
      setUpdateInOmie(false)
    }
  }, [shouldHideSwitches])

  useEffect(() => {
    if (isResource) {
      const sUnit = String((stock as any).stockUnit || '').trim().toUpperCase()
      if (['MM', 'MILIMETRO', 'MILÍMETRO', 'M LINEAR', 'M'].includes(sUnit)) {
        setUnitOfMeasurement('MM')
      } else if (['UN', 'UNIDADE', 'PC', 'PÇ'].includes(sUnit)) {
        setUnitOfMeasurement('UN')
      } else if (['KG', 'QUILO', 'KILO'].includes(sUnit)) {
        setUnitOfMeasurement('KG')
      } else if (Number((stock as any).lengthInMm) > 0 && Number(stock.totalWeight) === 0) {
        setUnitOfMeasurement('MM')
      } else if (Number((stock as any).unitQuantity) > 0 && Number(stock.totalWeight) === 0 && Number((stock as any).lengthInMm) === 0) {
        setUnitOfMeasurement('UN')
      }
    }
  }, [isResource, stock])

  useEffect(() => {
    setWarningMessage('')
  }, [stock, updateInOmie, updateInStock])

  useEffect(() => {
    const currentQuantity = Number(String(quantity).replace(',', '.'))
    const isNumber = !isNaN(currentQuantity) && isFinite(currentQuantity) && currentQuantity > 0

    if (isNumber) {
      const sign = movementType === 'Entrada' ? 1 : -1
      const currentKg = Number(stock.totalWeight) || 0
      const currentMm = Number(stock.lengthInMm) || 0
      const currentUnit = Number((stock as any).unitQuantity) || 0

      if (isResource) {
        if (unitOfMeasurement === 'KG') {
          setTotalKg(currentKg + sign * currentQuantity)
          setTotalMm(null)
          setTotalUnitQuantity(null)
        } else if (unitOfMeasurement === 'MM') {
          setTotalMm(currentMm + sign * currentQuantity)
          setTotalKg(null)
          setTotalUnitQuantity(null)
        } else {
          setTotalUnitQuantity(currentUnit + sign * currentQuantity)
          setTotalKg(null)
          setTotalMm(null)
        }
      } else {
        if (unitOfMeasurement === 'KG') {
          const newKg = currentKg + sign * currentQuantity
          setTotalKg(newKg)
          setTotalMm(kgToMm(newKg, stock))
          setTotalUnitQuantity(null)
        } else {
          const newMm = currentMm + sign * currentQuantity
          setTotalMm(newMm)
          setTotalKg(mmToKg(newMm, stock))
          setTotalUnitQuantity(null)
        }
      }
    } else {
      setTotalKg(null)
      setTotalMm(null)
      setTotalUnitQuantity(null)
    }
  }, [quantity, movementType, unitOfMeasurement, stock, isResource])

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target

    switch (name) {
      case 'movementType':
        setMovementType(value)
        break
      case 'observation':
        setObservation(value)
        break
      case 'unitOfMeasurement':
        setUnitOfMeasurement(value)
        break
      default:
        setStock({
          ...stock,
          [name]: value,
        })
        break
    }
  }

  const switches: string[] = ['omie', 'updateInStock']
  const switchesText: string[] = [
    unitOfMeasurement === 'KG'
      ? 'Movimentar peso na Omie'
      : 'Movimentar comp. na Omie',
    unitOfMeasurement === 'KG'
      ? 'Movimentar peso no estoque'
      : 'Movimentar comp. no estoque',
  ]
  const switchValues: boolean[] = [updateInOmie, updateInStock]

  const WarningBox = () => {
    if (!warningMessage) return null
    return (
      <WarningDiv>
        <WarningText>{warningMessage}</WarningText>
      </WarningDiv>
    )
  }

  const handleSwitchToggle = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name } = e.target
    switch (name) {
      case 'omie':
        setUpdateInOmie(!updateInOmie)
        break
      case 'updateInStock':
        setUpdateInStock(!updateInStock)
        break
      default:
        console.warn('Caminho inesperado ao ativar um switch toggle')
        break
    }
  }

  const handleSubmit = async () => {
    if (!quantity.trim()) {
      setWarningMessage('O campo Quantidade não pode estar vazio.')
      return
    }

    if (!shouldHideSwitches && !updateInOmie && !updateInStock) {
      setWarningMessage('Ative pelo menos uma opção de atualização.')
      return
    }

    setWarningMessage('')

    const newEntry = {
      codeId: stock.codeId,
      movementType,
      quantity: Number(String(quantity).replace(',', '.')),
      updateInOmie,
      updateInStock,
      observation,
      unitOfMeasurement,
      isResource,
      resourceId: isResource ? ((stock as any).resourceId || (stock as any).id) : undefined,
    }

    try {
      setWarningMessage('Salvando...')

      const response = await ApiService.post('/backend/handle-stock-movement', newEntry)

      if (response.status === 201 || response.status === 200) {
        if (updateInStock) {
          if (isResource) {
            setStock({
              ...stock,
              totalWeight: String(unitOfMeasurement === 'KG' && totalKg !== null ? totalKg : (stock.totalWeight ?? '')),
              lengthInMm: String(unitOfMeasurement === 'MM' && totalMm !== null ? totalMm : (stock.lengthInMm ?? '')),
              unitQuantity: String(unitOfMeasurement === 'UN' && totalUnitQuantity !== null ? totalUnitQuantity : ((stock as any).unitQuantity ?? '')),
            })
          } else {
            setStock({
              ...stock,
              totalWeight: String(totalKg !== null ? totalKg : (stock.totalWeight ?? '')),
              lengthInMm: String(totalMm !== null ? totalMm : (stock.lengthInMm ?? '')),
            })

            if (setStockList) {
              setStockList((prev: any[]) =>
                prev.map((item) =>
                  item.codeId === stock.codeId
                    ? {
                        ...item,
                        totalWeight: String(totalKg !== null ? totalKg : (item.totalWeight ?? '')),
                        lengthInMm: String(totalMm !== null ? totalMm : (item.lengthInMm ?? '')),
                      }
                    : item
                )
              )
            }
          }
        }

        setRefresh((prev) => !prev)
        setModalActive(false)
      } else {
        setWarningMessage('Erro inesperado. Tente novamente.')
      }
    } catch (error: any) {
      setWarningMessage(
        error.response?.data?.message || 'Erro ao salvar os dados. Verifique os campos e tente novamente.',
      )
    }
  }

  const productDetailsModal = () => {
    if (isResource) {
      setModalActive(false)
      return
    }
    setModalSection('newModal')
  }

  return (
    <Container>
      <HeaderDiv>
        <HeaderText>
          {itIsUpdate
            ? `Novo Movimento - ${stock.description}`
            : 'Adicionar Estoque'}
        </HeaderText>
        <CloseDiv onClick={() => setModalActive(false)}>
          <CloseImg src={cross} alt='Close tab' />
        </CloseDiv>
      </HeaderDiv>
      <InputRowDiv>
        <InputDiv>
          <InputLabel>Tipo</InputLabel>
          <SelectInputMoviment
            name='movementType'
            value={movementType}
            onChange={(e) => handleSelectChange(e)}
          >
            <SelectOption value='Entrada'>ENTRADA</SelectOption>
            <SelectOption value='Saída'>SAÍDA</SelectOption>
          </SelectInputMoviment>
        </InputDiv>
        <InputDiv>
          <InputLabel>Unidade</InputLabel>
          <SelectInputKgOrMm
            name='unitOfMeasurement'
            value={unitOfMeasurement}
            onChange={(e) => handleSelectChange(e)}
          >
            <SelectOption value='KG'>KG</SelectOption>
            <SelectOption value='MM'>MM</SelectOption>
            {isResource && <SelectOption value='UN'>UN</SelectOption>}
          </SelectInputKgOrMm>
        </InputDiv>
      </InputRowDiv>
      <br />
      <InputRowDiv>
        <InputDiv>
          <InputLabel>
            {unitOfMeasurement === 'KG'
              ? 'Peso atual'
              : unitOfMeasurement === 'MM'
              ? 'Comprimento atual'
              : 'Quantidade atual'}
          </InputLabel>
          <Input
            value={
              unitOfMeasurement === 'KG'
                ? (stock.totalWeight ?? '')
                : unitOfMeasurement === 'MM'
                ? (stock.lengthInMm ?? '')
                : ((stock as any).unitQuantity ?? '')
            }
            disabled
          />
        </InputDiv>

        <InputDiv>
          <InputLabel>Quantidade</InputLabel>
          <Input
            placeholder='Digite aqui'
            type='number'
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
          />
        </InputDiv>
      </InputRowDiv>
      {!shouldHideSwitches && (
        <SwitchesDiv>
          {switches.map((field, index) => (
            <SwitchDiv key={field}>
              <SwitchLabel htmlFor={field}>{switchesText[index]}</SwitchLabel>
              <SwitchBox>
                <SwitchInput
                  type='checkbox'
                  name={field}
                  checked={switchValues[index]}
                  onChange={handleSwitchToggle}
                />
                <SwitchSlider className='slider'></SwitchSlider>
              </SwitchBox>
            </SwitchDiv>
          ))}
        </SwitchesDiv>
      )}
      <InputRowDiv>
        <InputDiv>
          <InputLabel>Observação</InputLabel>
          <InputText
            name='observation'
            value={observation}
            onChange={(e) => handleSelectChange(e)}
            autoFocus
          />
        </InputDiv>

        <InputDiv style={{ marginLeft: '40px' }}>
          {isResource ? (
            <>
              <InputLabel>
                {unitOfMeasurement === 'KG'
                  ? 'Total em KG'
                  : unitOfMeasurement === 'MM'
                  ? 'Total em MM'
                  : `Total em ${unitOfMeasurement}`}
              </InputLabel>
              <Input
                value={
                  unitOfMeasurement === 'KG'
                    ? (totalKg !== null ? totalKg.toFixed(2) : '')
                    : unitOfMeasurement === 'MM'
                    ? (totalMm !== null ? totalMm.toFixed(2) : '')
                    : (totalUnitQuantity !== null ? String(totalUnitQuantity) : '')
                }
                disabled
                placeholder='0'
                style={{ height: '40px' }}
              />
            </>
          ) : (
            <>
              <InputLabel>Total em KG</InputLabel>
              <Input
                value={totalKg !== null ? totalKg.toFixed(2) : ''}
                disabled
                placeholder={unitOfMeasurement === 'MM' && quantity ? 'sem fórmula p/ formato' : '0'}
                style={{ height: '40px' }}
              />
              <br />
              <InputLabel>Total em MM</InputLabel>
              <Input
                value={totalMm !== null ? totalMm.toFixed(2) : ''}
                disabled
                placeholder={unitOfMeasurement === 'KG' && quantity ? 'sem fórmula p/ formato' : '0'}
                style={{ height: '40px' }}
              />
            </>
          )}
        </InputDiv>
      </InputRowDiv>
      <ButtonsDiv>
        <WarningBox />
        <PreviousButtonDiv onClick={productDetailsModal}>
          <PreviousButtonImage src={arrowLeft} alt='Right arrow icon' />
          <PreviousButtonText>Voltar</PreviousButtonText>
        </PreviousButtonDiv>
        <NextButtonDiv
          onClick={() => handleSubmit()}
          className={warningMessage !== '' && warningMessage !== 'Salvando...' ? 'disabled' : ''}
        >
          <NextButtonImage src={diskIcon} alt='Right arrow icon' />
          <NextButtonText>Salvar</NextButtonText>
        </NextButtonDiv>
      </ButtonsDiv>
    </Container>
  )
}

export default EntryOrExit

